<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button v-if="hasAdd" type="primary" @click="$router.push('/inspectionRecord/add?pointType=' + pointType)">新增</el-button>
      </template>
      <el-form inline ref="searchForm" class="global-form-label-width">

        <el-form-item prop="inspectDate" label="巡查日期">
          <el-date-picker v-model="searchForm.inspectDate" placeholder="请选择巡查日期" type="date" clearable
            format="yyyy-MM-dd" value-format="yyyy-MM-dd">
          </el-date-picker>
          <!--  -->
        </el-form-item>
        <el-form-item prop="pointId" label="巡查点位">
          <el-select v-model="searchForm.pointId" clearable filterable placeholder="请选择巡查结果">
            <el-option v-for="(item, index) of pointList" :value="item.pointId" :label="item.pointName"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="taskResult" label="巡查结果">
          <el-select v-model="searchForm.taskResult" clearable filterable placeholder="请选择巡查结果">
            <el-option v-for="(item, index) of resultArr" :value="item.value" :label="item.label"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card class="mt10" shadow="never">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column show-overflow-tooltip min-width="100" label="点位名称" prop="pointName"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="巡查日期" prop="inspectDate">

        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="巡查结果" prop="taskResult">
          <template v-slot="{ row }">
            <el-tag type="success" v-if="row.taskResult == '1'">正常</el-tag>
            <el-tag type="warning" v-if="row.taskResult == '2'">异常</el-tag>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="备注" prop="remark"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="巡查人" prop="createUserName"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="创建时间" prop="ctime"></el-table-column>

        <el-table-column fixed="right" label="操作" width="160">
          <template v-slot="{ row }">
            <el-button type="text"
              @click="$router.push('/inspectionRecord/detail?taskId=' + row.taskId + '&pointType=' + pointType)">详情</el-button>
            <el-button type="text" v-if="hasDel" @click="deleteRow(row.taskId)" class="del-btn">删除</el-button>

          </template>
        </el-table-column>
      </el-table>

      <el-pagination :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>

export default {
  name: 'inspectionRecord',

  data () {
    return {
      page: 1,
      total: 0,
      tableData: [],
      loading: false,
      searchForm: {
        inspectDate: null,
        taskResult: null,
        pointId: null
      },
      // 1正常2异常
      resultArr: [
        {
          label: '正常',
          value: '1'
        },
        {
          label: '异常',
          value: '2'
        }
      ],
      pointList: []
    }
  },
  computed: {
    pointType () {
      return this.$route.query.pointType // 点位类型1品控2安环
    },
    inspectDate() {
      return this.$route.query.inspectDate
    },
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasDel() {
      return this.buttonList.includes('delete')
    }
  },
  watch: {
    pointType (newV) {
      this.loadPoint()
      this.resetForm()
    }
  },
  created () {
    if (this.inspectDate) {
      this.searchForm.inspectDate = this.inspectDate
    } else {
      this.searchForm.inspectDate = this.$dayjs().format('YYYY-MM-DD')
    }
    this.loadPoint()
    this.loadData()
  },
  methods: {
    loadPoint () {
      this.$axios.get(this.$apis.inspectionPoint.selectPaInspectPointByPage, {
        params: {
          pointType: this.pointType
        }
      }).then(res => {
        this.pointList = res.list || []
      })
    },
    loadData () {
      this.loading = true
      this.$axios.get(this.$apis.inspectionRecord.selectPaInspectTaskByPage, {
        params: {
          page: this.page,
          ...this.searchForm,
          pointType: this.pointType
        }
      }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },

    onSearch () {
      this.page = 1
      this.loadData()
    },
    resetForm () {
      this.$refs.searchForm.resetFields()
      this.searchForm = {
        inspectDate: null,
        taskResult: null,
        pointId: null

      }
      this.onSearch()
    },
    deleteRow (taskId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.inspectionRecord.deleteDataPaInspectTask, {
          taskId
        }).then(() => {
          this.loadData()
        })
      })
    }

  }
}
</script>

<style scoped lang='scss'>
.btn {
  text-decoration: underline;
  color: #007bff;
  cursor: pointer;
}
</style>
